import type { ApiLocation, Category, CategoryStyle } from "./model";

/** Neutral fill for a location with no units and no custom colour. */
export const UNASSIGNED_FILL = "#e5e7eb";

/** Category of the unit with the lowest `floorOrder` (ground level / representative unit). */
export function representativeCategory(loc: ApiLocation): Category | undefined {
  if (!loc.units.length) return undefined;
  return loc.units.reduce((lowest, u) => (u.floorOrder < lowest.floorOrder ? u : lowest)).category;
}

/**
 * A location's parcel fill colour: its own custom fill wins when `colorMode`
 * is "custom"; otherwise (or if no custom fill is set) it's the API category
 * style's fill for the representative (lowest-floorOrder) unit's category.
 */
export function parcelFill(
  loc: ApiLocation,
  stylesByCategory: Map<Category, CategoryStyle>,
  fallback = UNASSIGNED_FILL,
): string {
  if (loc.colorMode === "custom" && loc.customFill) return loc.customFill;
  const cat = representativeCategory(loc);
  if (!cat) return fallback;
  return stylesByCategory.get(cat)?.fill ?? fallback;
}
